const ErrorCode = Object.freeze({
    INVALID_CREDENTIAL: 1442,
    INVALID_CREDENTIAL_PW: 1443,
    USER_INACTIVE: 1449,
    PASSWORD_POLICY_UNMATCHED: 1457,
    INVALID_PAYMENT_STATUS: 4709, // NOTE: when trying to authorise/register, the payment is not valid to do so
    INSUFFICIENT_BALANCE_LIMIT_REACHED: 4717,
    INVALID_PAYMENT_METHOD: 4721,
    INVALID_ACCESS: 4732,
    SESSION_TIMEOUT: 4741,
    WEB_PAYMENT_LIMIT_REACHED: 4742,
    MAX_LOGIN_REACHED: 4743,
    MAX_TRANSACTION_PIN_REACHED: 4744,
    MAX_LOYALTY_REDEMPTION_REACHED: 4765,
    MOBILE_NOT_REGISTERED: 9900, 
    MAX_OTP_RESEND_REACHED: 9916,
    INVALID_OTP: 9918,
    MAX_OTP_RETRY_REACHED: 9925,
    INVALID_TRANSACTION_PIN: 9927,
    CONFIRM_PIN_NOT_MATCH: 1442,
    TRANSACTION_PIN_NOT_SET: 9928,
    HTTP_BAD_REQUEST: 400,
    HTTP_NOT_FOUND: 404,
    OTP_EXCEEDED_DAILY_MAX_RESEND_ERROR: 9936,
    OTP_REQUEST_TIMEOUT_ERROR: 9937,
});

const PaymentStatus = Object.freeze({
    AUTHORISED: 'Authorised',
    FAILED: 'Failed',
    PENDING_AUTHORISE: 'PendingAuthorise',
    CANCELLED: 'Cancelled',
    EXPIRED: 'Expired',

    LIMIT_REACHED: 'Limit Reached',
});

const LoyaltyInfoAccountStatus = Object.freeze({
    NormalPrincipal: 'NormalPrincipal',
    NormalPrincipalPINRequired: 'NormalPrincipalPINRequired',
    NormalPrincipalOTPRequired: 'NormalPrincipalOTPRequired',
    NormalSupplementary: 'NormalSupplementary',
    MissingPoints: 'MissingPoints',
    Unlinked: 'Unlinked',
});

export {
    ErrorCode,
    PaymentStatus,
    LoyaltyInfoAccountStatus,
};